/* eslint-disable */
const storage = window.localStorage;

class LocalStorage {

  static set namespace (name) {
    this._namespace = name;
  }

  static get namespace () {
    return this._namespace = this._namespace ? this._namespace : Date.now();
  }

  static getAllItems () {
    try {
      return storage.getItem(this.namespace) === null ? {} : JSON.parse(storage.getItem(this.namespace));
    } catch(e) {
      return {};
    }
  }

  static setItem (key, value) {
    const allItems = this.getAllItems();
    const values = Object.assign(allItems,{[key] : value});
    storage.setItem(`${this.namespace}`, JSON.stringify(values));
  }

  static getItem (key) {
    const allItems = this.getAllItems();
    return allItems.hasOwnProperty(key) ? allItems[key] : '';
  }

  static removeItem (key) {
    let values = Object.assign({},this.getAllItems());
    delete values[key];
    storage.setItem(this.namespace, JSON.stringify(values));
  }

  static removeAllItems () {
    storage.clear();
  }

}

export default LocalStorage;



// WEBPACK FOOTER //
// ./helpers/local-storage.js